
import React from 'react'
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from '../../../contexts/AITestContext'
import { useState, useEffect} from 'react'
import { DisplayAllTests } from '../aitest/DisplayAllTests'
import { DisplayChosenTests } from '../aitest/DisplayChosenTests'
import { ExpandLess, ExpandMore } from "@mui/icons-material"
import { Row, Col } from 'react-bootstrap';
import { ProgressIcon } from '../customicons/ProgressIcon';
import { Description } from '../aitest/Description'
import { SearchText } from '../searchtext/SearchText'
import { BuyTestDialog } from '../purchasetest/BuyTestDialog'
import { Questions } from "../aitest/Questions"
import { DialogTestLanguage } from './DialogTestLanguage';
import { TestLanguage } from './TestLanguage'
import { PageTitle } from './PageTitle'
import "./aitest.css"

export const ChooseTest = () => {


  const [showalltests, setShowAllTests] = useState(true)
  const [searchname, setSearchName] = useState('')
  const [searchauthor, setSearchAuthor] = useState('')
  const [tempchatNames, setTempChatNames] = useState([])

  const {
    isMobile,
    changeLanguage,
    setTestLanguage,
    language
  } = React.useContext(StatusContext);

  const {
    promptsandresponses,
    chatNames,
    boughtchatNames,
    deleteChat,
    displayChat,
    displayBoughtTest,
    setChatName,

    isLoading,

    description,
    onChangeDescription,
    descriptionRef,
    handleDescriptionFocus,
    getTestLanguage,
    onLoadBoughtTests,
    showfavouritetests,


  } = React.useContext(AITestContext);

  useEffect(() => {
    console.log("useEffect: ChooseTest")
    let b = []
    let a = [...chatNames]

    //set indexes
    for (let i = 0; i < a.length; i++) {
      if (a[i].activated === 1)
        b.push(a[i])
    }
    setTempChatNames([...b])
    setTestLanguage(getTestLanguage())
  }, [chatNames, setTestLanguage, getTestLanguage]);


  const handleShowAllTests = () => {
    onShowAllTests()
  }

  
  const onSearchName = (e) => {

    const a = chatNames.filter(element => element.chatname.toLowerCase().startsWith(e.target.value.toLowerCase()));

    let b = []
    //set indexes
    for (let i = 0; i < a.length; i++) {
      if (a[i].activated === 1)
        b.push(a[i])
    }
    setTempChatNames([...b])
    setSearchName(e.target.value)
    setSearchAuthor('')

  }

  const onSearchAuthor = (e) => {

    const a = chatNames.filter(element => element.creator_name.toLowerCase().startsWith(e.target.value.toLowerCase()));

    let b = []
    //set indexes
    for (let i = 0; i < a.length; i++) {
      if (a[i].activated === 1)
        b.push(a[i])
    }
    setTempChatNames([...b])
    setSearchAuthor(e.target.value)
    setSearchName('')


  }
  
  const onShowBoughtTests = () => {

    onLoadBoughtTests()

  }
  
  const onShowAllTests = () => {
    console.log("onShowAlltests")
    setShowAllTests(!showalltests)
  }

  return (

    <div>
      <PageTitle title = {changeLanguage('aitest', 'choosetesttitle')} />
   
      <Row>
      <Col className="aitestChooseColumn" style={{ width: "100%", paddingLeft:isMobile() ? '3%' : '10%',   paddingRight: isMobile() ? '3%' : '10%'}}>
          {
            <>
            <TestLanguage language={language}/>

            <div className="aitestactionbutton" onClick={() => { onShowBoughtTests() }}>
              {
                (showfavouritetests) ?
                  <ExpandLess className="aitestIcon" />
                  :
                  <ExpandMore className="aitestIcon" />
              }
              {changeLanguage('aitest', 'purchasedtests')}
            </div>
            </>
          }

          {
            (showfavouritetests) &&
            <>
              <br/>
              <div className="displayTestsContainer">
                  {
                    Array.isArray(boughtchatNames) &&
                    boughtchatNames.map((chat) => (
                      <React.Fragment key={chat.id}>
                        <DisplayChosenTests key={chat.id} chat={chat} deleteHandler={deleteChat} clickHandler={displayBoughtTest} setTemplateName={setChatName} handleFocus={handleDescriptionFocus} />
                      </React.Fragment>
                    ))
                  }
              </div>
            </>
          }
          <br/>
        </Col>
      </Row>
 
      <Row>
           <Col style={{ width: "100%", paddingLeft:isMobile() ? '3%' : '10%',   paddingRight: isMobile() ? '3%' : '10%'}}>
              <div className="aitestactionbutton" onClick={handleShowAllTests}>
                {
                  (showalltests) ?
                    <ExpandLess className="aitestIcon" />
                    :
                    <ExpandMore className="aitestIcon" />
                }
                {changeLanguage('aitest', 'alltestssubtitle')}
              </div>
              {
                (showalltests) &&
                <>
                <br/>
                  <div className="displayTestsContainer navbarNames">
                      {
                        Array.isArray(tempchatNames) &&
                        tempchatNames.map((chat, idx) => (
                          <React.Fragment key={chat.id}>
                            <DisplayAllTests key={chat.id}
                              chat={chat}
                              deleteHandler={deleteChat}
                              clickHandler={displayChat}
                              setTemplateName={setChatName}
                              handleFocus={handleDescriptionFocus}
                              seqid={idx + 1}
                              total={tempchatNames.length}
                            />
                          </React.Fragment>
                        ))
                      }
                  </div>
                  </>
              }

            {
              (showalltests && isMobile()) ?
                <>
                  <br></br>
                
                  <div>
                    <SearchText label={changeLanguage('general', 'searchname')} text={searchname} onSearch={onSearchName} />
                  </div>
                  <br></br>
                  <div syle={{ width: '80%' }}>
                    <  SearchText label={changeLanguage('general', 'searchauthor')} text={searchauthor} onSearch={onSearchAuthor} />
                  </div>
                  <br />
                </>
                :
                <></>
            }

            {
              (showalltests && !isMobile()) ?
                <>
                <br/>
                  <div>
                    <SearchText label={changeLanguage('general', 'searchname')} text={searchname} onSearch={onSearchName} />
                  </div>
                  <br></br>
                  <div>
                    <SearchText label={changeLanguage('general', 'searchauthor')} text={searchauthor} onSearch={onSearchAuthor} />
                  </div>
                </>
                :
                <br></br>
            }
          </Col>
        </Row>

    
        {
              promptsandresponses.length !== 0 &&
              <>
              <div  ref={descriptionRef} style={{ width: "100%", paddingLeft:isMobile() ? '0%' : '10%',   paddingRight: isMobile() ? '0%' : '10%'}}>
              <Description
                title={changeLanguage('aitest', 'description')}
                description={description}

                disabled={true}
                onChange={onChangeDescription} />
              </div>
      
            <div >
              <Questions />
            </div>
        </>
}
        
      <DialogTestLanguage />
      <BuyTestDialog />
      <ProgressIcon isLoading={isLoading} />
    </div>
  )
}
